import { Injectable } from '@angular/core';
@Injectable()
export class PathRoutes {
  // login
  public static login = 'login';

  // welcome
  public static welcome = 'welcome';

  // error
  public static error = 'error';

  // Gestión del empleado
  public static home = 'home';
  public static employee = 'employee';
  public static holidays = 'holidays';
  public static bolsa = 'bolsa';
  public static periodos = 'periodos';
  public static liquidaciones = 'liquidaciones';
  public static asignarTipoCalculoEmpleado = 'employee-type-calc';

  // Gestión de It
  public static its = 'it';
  public static substitution = 'substitution';

  // Gestión de empleados
  public static gestionEmpleados = 'gestion-empleados';
  public static empleados = 'empleados';
  public static tramosCodigoEmpleados = 'tramos-codigo-empleados';

  // Informes
  public static reports = 'reports';
  public static requestedDays = 'requestedDays';

  // config
  public static config = 'config';

  // my account
  public static myAccount = 'my-account';
  public static myCompany = 'my-company';
  public static myConfig = 'my-config';
  public static myUsers = 'my-users';
  public static myProcess = 'my-process';
  public static mySubscriptions = 'my-subscriptions';

  public static admin = 'administration';

  public static conectia = 'a3laboral';


   // Portal del Empleado

   public static app = 'app';

   public static appConfig = 'app-config';
   public static appReqs = 'app-reqs';
   public static appClockingConfig = 'app-attendance-clocking';
   public static appClocking = 'app-attendance';
   public static appClockings = 'app-attendance-list';
   public static appDocuments = 'app-docs';
   public static appIncidents = 'app-incidents';
   public static appKlikTicket = 'app-klikticket';
   public static appCompanies = 'app-companies';
   public static appEnvConfig = 'app-config-environment';
   public static appUsers = 'app-users';
   public static appRequests = 'app-requests';
   public static appDocs = 'app-documents';
   public static appOnboarding = 'app-documents-onboarding';
   public static appBulletinBoard = 'app-bulletin-board';
   public static appChat = 'app-chat';
   public static appUploadDocs = 'app-upload-documents';
   public static appViewIncidents = 'app-incidents-view';
   public static appRedirectMyReportin = 'app-redirect-myreportin';
   public static appRedirectApp = 'app-redirect-app';
   public static appRedirectHostel = 'app-redirect-hostel';
   public static a3Doc = 'a3doc-cloud';

  // pre-login user actions
  public static activateUser = 'user-activate';
  public static newPassword = 'new-password';
  public static finalizeRegister = 'finalize-register';
  public static restorePassword = 'restore-password';
}
